var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { HTTPError, generateUUID } from "syf-js-utilities";
const JSON_CONTENT_TYPE = "application/json";
const getTrackingHeaders = () => {
  return {
    "x-syf-request-trackingid": generateUUID()
  };
};
const getAuthHeaders = () => {
  const accessToken = sessionStorage.getItem("accessToken");
  const correlationId = sessionStorage.getItem("correlationId");
  return {
    Authorization: `Bearer ${accessToken}`,
    "x-syf-request-correlationid": correlationId != null ? correlationId : ""
  };
};
const getFetchWrapper = (config) => {
  function fetchWrapper(url, init) {
    return __async(this, null, function* () {
      var _b, _c;
      const fullUrl = new URL(url, config.hosts.apigee);
      const _a = init, { headers = {} } = _a, rest = __objRest(_a, ["headers"]);
      const methodsListWithoutContentType = ["GET", "DELETE"];
      let contentType = JSON_CONTENT_TYPE;
      if (!init.method || methodsListWithoutContentType.includes((_b = init.method) == null ? void 0 : _b.toUpperCase())) {
        contentType = "";
      }
      const response = yield fetch(fullUrl.toString(), __spreadValues({
        mode: "cors",
        headers: __spreadValues(__spreadValues(__spreadValues({
          "Content-Type": contentType,
          Accept: "application/json"
        }, getAuthHeaders()), getTrackingHeaders()), headers)
      }, rest));
      if (!response.ok) {
        const err = new HTTPError(response);
        config.apiErrorCallback(err);
        throw err;
      }
      const responseContentType = (_c = response.headers.get("content-type")) != null ? _c : "";
      if (response.status === 204 || !responseContentType.includes(JSON_CONTENT_TYPE)) {
        return null;
      }
      try {
        const text = yield response.text();
        return JSON.parse(text);
      } catch (_e) {
        throw new HTTPError(response);
      }
    });
  }
  return fetchWrapper;
};
export {
  getFetchWrapper
};
//# sourceMappingURL=getFetchWrapper.js.map
